import http from './http'
import store from '@/store'

// Vuex(login 모듈) 가 토큰/닉네임의 단일 소스. localStorage 영속화는 vuex-persistedstate 가 담당.
export async function login(args) {
    return await http.post("/admin/login", JSON.stringify(args)).then(
        response => {
            if (response.status === 201) {
                const { token, nickname } = response.data.response;
                store.commit('login/setUser', { token, nickname });
            }
        })
        .catch((error) => {
            alert("입력하신 정보가 올바르지 않습니다. 입력하신 정보를 확인해주세요.");
            throw error;
        })
}

export async function logout(args) {
    const clearSession = () => store.commit('login/setUser', { token: null, nickname: '' });
    return await http.post("/admin/logout", null, { params: args }).then(clearSession)
        .catch((error) => {
            // 서버 요청 실패해도 로컬 상태는 클리어
            clearSession();
            console.error("로그아웃 요청에 실패했습니다. 로컬 세션은 종료되었습니다.");
            throw error;
        })
}